<template>
<div class="receivedCouponLayer_ui">
    <div class="received-coupon-layer">
        <div class="received-coupon-box">
            <div class="head">
                <img src="https://xcx.ihotel.cn/mall/images/received-coupon-bg.png">
            </div>
            <div class="received-coupon-info">
                <div class="title"><i class="icontixing1 iconfont"></i>以下{{memberType.totalNum}}张券，您可以选择性领取{{memberType.selectedNum}}张</div>
                <div class="received-coupon-list">
                    <div class="received-coupon-item" v-for="(item,i) in memberType.rewardArray" :key="i">
                        <div class="no-sell" v-if="item.sellableCount<=0"></div>
                        <div class="received-coupon-item-lf">
                            <div class="coupon-item-name">{{item.descript}}</div>
                            <div class="coupon-item-desc">{{item.introduction}}</div>
                        </div>
                        <div class="received-coupon-btn" @click="chooseCouon(item)">
                            <i class="iconfont iconxuanzhong" v-if="item.active"></i>
                            <i class="iconfont iconweixuan1" v-else></i>

                        </div>

                    </div>
                </div>
                <div class="received-coupon-btn-box">
                    <div class="received-coupon" @click="receiveSCCoupon">
                        <div class="received-coupon-content">一键领取</div>
                        <div class="received-coupon-bg"></div>
                    </div>

                </div>

                <div class="go-received-coupon-info" @click="goCouponInfo" v-if="toLink=='T'">查看活动详情</div>
            </div>

            <div class="close" @click="closeLayer"><i class="iconshanchu1 iconfont"></i></div>
        </div>
    </div>
</div>
</template>

<script>
import api from '@/utils/api';
import moment from 'moment';
import {
    setStorage,
    getStorage
} from '@/utils/wxuser';
import {
    jAlert3
} from '@/base/jAlert/jAlert';
import {
    urlEncode,
    createUrl
} from '@/utils/index';
import gcTrack from "@/utils/gcTrack";
var config = {};
export default {
    data() {
        return {
            wxuser: '',
            user: getStorage('user'),
            coupons: [],
            isTap: false,
            isAjax: false,
            hotelCode: 0,
            isReceivedCouponLayer: false,
            memberType: {}
        };
    },
    props: {
        coupon: {
            type: Object,
            default () {
                return {};
            }
        },
        toLink:{
            type: String,
            default () {
                return 'T';
            }
        }
    },
    methods: {

        receiveSCCoupon() {
            var coupon = this.coupon
            var number = 0
            var rewardValues = []
            this.memberType.rewardArray.forEach(item => {
                if(item.active){
                    rewardValues.push(item.code)
                    number++
                }
            });
            if(number<=0){
                jAlert3('请选择优惠券')
                return false;
            }
             if(number<this.memberType.selectedNum){
                jAlert3(`请选择${this.memberType.selectedNum}张优惠券`)
                return false;
            }
            if(number>this.memberType.selectedNum){
                jAlert3(`最多选择${this.memberType.selectedNum}张优惠券`)
                return false;
            }
            if (this.isTap) {
                return false;
            }
            this.isTap = true;
            var obj = {
                couponCode: coupon.couponCode,
                hotelGroupCode: config.hotelGroupCode,
                hotelGroupId: config.hotelGroupId,
                memberId: this.user.memberId,
                hotelCode: coupon.hotelCode,
                appid: config.appid,
                openid: this.wxuser.openid,
                couponType: coupon.couponType,
                mobile: this.user.mobile,
                promotionCode:this.memberType.promotionCode,
                promotionNo:this.memberType.promotionNo,
                rewardValue:rewardValues.join(',')

            };
            this.getCurrentCard();
            var chuzhiIndex = getStorage("cardIndex") || 0;
            obj.cardId = this.user.cardListDto[chuzhiIndex].cardId;
            obj.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
            obj.cardNo = this.user.cardListDto[chuzhiIndex].cardNo;
            obj.url = createUrl(obj)
            api.receiveSCCouponNew(obj).then((res) => {
                this.isTap = false;
                if (res.result == 1) {
                    jAlert3('领取成功');
                    gcTrack.track("SC_ReceiveDiscount", {
                        discount_id: coupon.id,
                        discount_name: coupon.name,
                        discount_amount: coupon.presentValue,
                        discount_type: coupon.couponType
                    })
                    this.coupons = [];
                    setTimeout(()=>{
                        this.$emit('closeLayer','T')
                    },1000)
                    
                   
                } else {
                    jAlert3(res.msg);
                }
                console.log(res);
            });
        },
        chooseCouon(item) {
            if (item.active) {
                this.$set(item, 'active', false)
            } else {
                this.$set(item, 'active', true)
            }
        },
        goCouponInfo() {
            this.$router.push({
                path: '/couponInfo',
                query: {
                    hotelCode: this.coupon.hotelCode || 0,
                    activityId: this.coupon.id,
                },
            });
        },
        closeLayer() {
            this.$emit('closeLayer')
        }
    },
    created() {
        config = getStorage('config');
    },
    mounted() {
        this.memberType = this.coupon.memberType[0]
    }
}
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.received-coupon-layer {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.50);

    .received-coupon-box {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 8.533333rem;

        .head {
            img {
                width: 100%;
            }
        }

        .received-coupon-info {
            margin-top: -1px;
            padding: 0.266667rem;
            background: #FF4A32;
            border-radius: 0px 0px 0.533333rem 0.533333rem;

            .title {
                font-family: PingFangSC-Medium;
                font-size: 14px;
                color: #FFFFFF;

                i {
                    margin-right: 0.08rem;
                }
            }

            .received-coupon-list {
                max-height: 8.533333rem;
                overflow-y: auto;
                
                .received-coupon-item {
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-top: 0.266667rem;
                    padding: 0 0.533333rem;
                    line-height: 1.4;
                    box-sizing: border-box;
                    width: 8rem;
                    height: 2.346667rem;
                    background: url(https://xcx.ihotel.cn/mall/images/received-coupon-item-bg.png) no-repeat;
                    background-size: contain;
                    overflow: hidden;
                    border-radius: 0.32rem;
                    .no-sell{
							position: absolute;
							left:0;
							top: 0;
							width: 100%;
							height: 100%;
							background: rgba(255,255,255,0.9);
						}
                    .noAvail-box {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        background: rgba(255, 255, 255, 0.80);
                    }

                    &.noAvail {
                        .noAvail-box {
                            display: block;
                        }

                    }

                    .received-coupon-item-lf {
                        flex: 1;

                        .coupon-item-name {
                            font-family: PingFangSC-Semibold;
                            font-size: 20px;
                            color: #333333;
                            letter-spacing: 0;
                            font-weight: 600;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            overflow: hidden;
                        }

                        .coupon-item-desc {
                            padding-right: 0.266667rem;
                            margin-top: 0.08rem;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #666666;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            overflow: hidden;
                        }
                    }

                    .received-coupon-btn {
                        i {
                            font-size: 28px;
                            color: #FF4A32;

                        }
                    }
                }
            }

            .go-received-coupon-info {
                margin-top: 0.266667rem;
                text-align: center;
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #FFFFFF;
                letter-spacing: 0;
                font-weight: 600;
            }
        }

        .close {

            display: flex;
            justify-content: center;

            i {
                margin-top: 0.4rem;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                font-size: 30px;
                color: #fff;
            }
        }
    }

    .received-coupon-btn-box {
        display: flex;
        justify-content: center;
        margin-top: 0.32rem;
        .received-coupon {
            position: relative;
            height: 1.173333rem;
            width: 4.8rem;
            .received-coupon-content {
                position: absolute;
                width: 4.8rem;
                top: 0;
                z-index: 2;
                display: flex;
                justify-content: center;
                align-items: center;
               
                height: 1.12rem;
                background-image: linear-gradient(270deg, #FACA5A 0%, #FAF0BC 100%);
                border-radius: 0.586667rem;
                font-family: PingFangSC-Semibold;
                font-size: 20px;
                color: #E41D02;
                letter-spacing: 0;
                text-align: center;
                font-weight: 600;
            }

            .received-coupon-bg {
                top: 0.053333rem;
                 border-radius: 0.586667rem;
                position: absolute;
                left: 0;
                right: 0;
                height: 1.173333rem;
                width: 4.8rem;
                background: #F09B23;
            }
        }

    }

}
</style>



// WEBPACK FOOTER //
// src/components/receivedCouponLayer.vue